var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":_vm.customType},domProps:{"value":_vm.customValue},on:{"click":function($event){return _vm.adicionarProdutoNoCarrinho(_vm.produto)}}})}
var staticRenderFns = []

export { render, staticRenderFns }